import React from "react";
import { motion } from "framer-motion";
import { useLang } from "@/context/LanguageContext";
import { T, IMAGES } from "@/content/site";

const items = [
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/q7p5c4oa_WhatsApp%20Image%202026-08-03%20at%2010.32.56.jpeg",
    label: { es: "Oaxaca · Fachada colonial", en: "Oaxaca · Colonial façade" },
    cls: "col-span-12 md:col-span-8 md:h-[560px] aspect-[4/3] md:aspect-auto",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/842z1rkq_WhatsApp%20Image%202026-08-03%20at%2010.31.25.jpeg",
    label: { es: "Nueva York · SACRVM Madrecuishe", en: "New York · SACRVM Madrecuishe" },
    cls: "col-span-12 md:col-span-4 md:h-[560px] aspect-[4/5] md:aspect-auto",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/tiwvhx6m_WhatsApp%20Image%202026-08-03%20at%2010.31.24%20%283%29.jpeg",
    label: { es: "Detalle · Colección Madrecuishe 48", en: "Detail · Madrecuishe 48 collection" },
    cls: "col-span-6 md:col-span-4 aspect-square",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/ynmx3diw_WhatsApp%20Image%202026-08-03%20at%2010.31.24%20%284%29.jpeg",
    label: { es: "Campo · Sierra oaxaqueña", en: "Field · Oaxacan sierra" },
    cls: "col-span-6 md:col-span-8 aspect-[3/2] md:aspect-[16/9]",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/wg2zn96i_WhatsApp%20Image%202026-08-03%20at%2010.31.24%20%282%29.jpeg",
    label: { es: "Ritual · Ensamble en mesa", en: "Ritual · Ensamble at table" },
    cls: "col-span-12 aspect-[16/9] md:aspect-[21/9]",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/g5rmry81_WhatsApp%20Image%202026-08-03%20at%2010.37.16%20%282%29.jpeg",
    label: { es: "Mayfair Grill · Madrecuishe 48", en: "Mayfair Grill · Madrecuishe 48" },
    cls: "col-span-12 md:col-span-5 aspect-[4/5]",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/xljixi3w_WhatsApp%20Image%202026-08-03%20at%2010.37.16%20%281%29.jpeg",
    label: { es: "Palapa · Cardones", en: "Palapa · Cardones" },
    cls: "col-span-12 md:col-span-7 aspect-[4/3]",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/8tq351q1_WhatsApp%20Image%202026-08-03%20at%2010.37.16.jpeg",
    label: { es: "México · Silueta al atardecer", en: "Mexico · Sunset silhouette" },
    cls: "col-span-12 md:col-span-7 aspect-[16/10]",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/9c4up0ej_WhatsApp%20Image%202026-08-03%20at%2010.31.24%20%281%29.jpeg",
    label: { es: "JATTO · Madrecuishe en barra", en: "JATTO · Madrecuishe at the bar" },
    cls: "col-span-12 md:col-span-5 aspect-[4/5]",
  },
  {
    src: "https://customer-assets-wrfwihn1.emergentagent.net/job_mezcal-luxury/artifacts/efhw8l3v_WhatsApp%20Image%202026-08-03%20at%2010.31.24.jpeg",
    label: { es: "Cultivo · Agave azul", en: "Cultivation · Blue agave" },
    cls: "col-span-12 aspect-[16/9] md:aspect-[21/9]",
  },
];

export default function Gallery() {
  const { t } = useLang();
  return (
    <section id="gallery" data-testid="gallery-section" className="relative bg-[#0F0F0F] py-[140px] md:py-[180px] border-t border-white/5">
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <div className="grid grid-cols-12 gap-8 mb-16 md:mb-24 items-end">
          <div className="col-span-12 md:col-span-6">
            <motion.div initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }} className="overline mb-8">
              <span className="inline-block w-8 h-px bg-[color:var(--sacrvm-gold)] align-middle mr-3" />
              {t(T.gallery.overline)}
            </motion.div>
            <motion.h2
              initial={{ opacity: 0, y: 30 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 1 }}
              className="font-serif text-white text-[42px] md:text-[72px] leading-[1] tracking-[-0.01em]"
            >
              {t(T.gallery.title)}
            </motion.h2>
          </div>
          <div className="col-span-12 md:col-span-4 md:col-start-9 text-right hidden md:block">
            <div className="overline !text-white/40">Oaxaca · MMXXV</div>
          </div>
        </div>

        <div className="grid grid-cols-12 gap-4 md:gap-6">
          {items.map((it, i) => (
            <motion.figure
              key={i}
              initial={{ opacity: 0, y: 40 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.9, delay: (i % 4) * 0.06, ease: [0.19, 1, 0.22, 1] }}
              className={"img-hover relative overflow-hidden bg-[#141414] " + it.cls}
              data-testid={`gallery-item-${i}`}
            >
              <img src={it.src} alt={t(it.label)} loading="lazy" className="w-full h-full object-cover" />
              <figcaption className="absolute bottom-4 left-4 text-white/85 text-[11px] tracking-[0.22em] uppercase bg-black/40 backdrop-blur-md px-3 py-1.5">
                {t(it.label)}
              </figcaption>
            </motion.figure>
          ))}
        </div>
      </div>
    </section>
  );
}
